import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=2d2b851a&scoped=true"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"
import style0 from "./Countdown.vue?vue&type=style&index=0&id=2d2b851a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b851a",
  null
  
)

export default component.exports